export function rowRangeSelector(row: number, cols: number): string {
  const fromSelector = `:nth-child(n + ${cols * row + 1})`;
  const toSelector = `:nth-child(-n + ${cols * (row + 1)})`;

  return fromSelector + toSelector;
}

